 
export const getB2BProduct=(state)=>{    
    return state.b2b_button.product;    
}

export const showModal=(state)=>{    
    return state.b2b_button.show_modal;    
}

export const currentPage=(state)=>{    
    return state.b2b_button.page;    
}

export const groupeType=(state)=>{    
    return state.b2b_button.group_type;    
}

export const getCreatedCircle=(state)=>{    
    return state.b2b_button.created_circle;    
}



 